import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app.store'
import auth from './modules/auth.store'
import user from './modules/user.store'
import menu from './modules/menu.store'
import live from './modules/live.store'
import plan from './modules/plan.store'
import player from './modules/player.store'
import course from './modules/course.store'
import checkout from './modules/checkout.store'
import invoice from './modules/invoice.store'
import support from './modules/support.store'
import playlist from './modules/playlist.store'
import userCard from './modules/userCard.store'
import purchase from './modules/purchase.store'
import courseGroup from './modules/courseGroup.store'
import slideSidebar from './modules/slideSidebar.store'
import notification from './modules/notification.store'
import subscription from './modules/subscription.store'
import courseCategory from './modules/courseCategory.store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    auth,
    user,
    menu,
    live,
    plan,
    player,
    course,
    checkout,
    invoice,
    support,
    playlist,
    userCard,
    purchase,
    courseGroup,
    notification,
    slideSidebar,
    subscription,
    courseCategory,
  }
})

export default store
